import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import documentFetched, {
	type DocumentFetchedAction,
	type DocumentDetailPayload,
} from '@Application/Beneficiaries/Documents/Actions/documentFetched';
import documentFetchFailed, {
	type DocumentFetchFailedAction,
} from '@Application/Beneficiaries/Documents/Actions/documentFetchFailed';
import type FetchDocument from '@Application/Beneficiaries/Documents/Queries/FetchDocument';
import { get } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = DocumentFetchedAction | DocumentFetchFailedAction;

export default (query: FetchDocument) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<DocumentDetailPayload>(
				`${buildSubjectApiPath(query.facilityId, query.subject)}/documents/${query.documentId}`,
			);

			const action = documentFetched(payload, query.facilityId, query.subject.subjectId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
